import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-plus-square",
  "use": "icon-plus-square-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" class=\"feather feather-plus-square\" id=\"icon-plus-square\"><rect x=\"3\" y=\"3\" width=\"18\" height=\"18\" rx=\"2\" ry=\"2\" /><line x1=\"12\" y1=\"8\" x2=\"12\" y2=\"16\" /><line x1=\"8\" y1=\"12\" x2=\"16\" y2=\"12\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol